import {
    Component,
    EventEmitter,
    HostListener,
    Input,
    Output,
    ViewChild
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { Driver } from '../verification-drivers-page/verification-drivers.model';

@Component({
    selector: 'self-ins-drivers-modal',
    templateUrl: './drivers-modal.component.html',
    styleUrls: ['./drivers-modal.component.scss']
})
export class DriversModalComponent {
    @Input() public visible = false;
    @ViewChild('form', { static: false }) public form: NgForm | undefined = undefined;
    public data: Driver = {} as Driver;

    @Output() public onHidden = new EventEmitter<Driver | null>();

    public show(driver: Driver) {
        Object.assign(this.data, driver);
        this.visible = true;
    }

    @HostListener('window:keyup', ['$event'])
    public onWindowKeyUp($event: KeyboardEvent) {
        if ($event.defaultPrevented) {
            return; // Do nothing if the event was already processed
        }

        if ($event.key === 'Escape') {
            this.hide();
        }

        if ($event.key === 'Enter') {
            this.form?.ngSubmit.emit();
            this.onSubmit();
        }
    }

    public hide() {
        this.data = {} as Driver;
        this.onHidden.emit(null);
        this.visible = false;
    }

    public onSubmit() {
        const stateReg = new RegExp('^[a-zA-Z]{2,2}$');
        if (this.form?.invalid || !this.data.firstName || !this.data.lastName
            || !(this.data.licensedState.length && stateReg.test(this.data.licensedState))
        ) {
            return;
        }
        this.onHidden.emit(this.data);
        this.data = {} as Driver;
        this.visible = false;
    }

    handleDateChange(event: any) {
        const dateValue = event.target.value;
        if (!dateValue) {
            this.data.termDate = null;
        }
    }
}